<script>
    import { Link } from "svelte-navigator";
    import { MasonryGrid } from "@egjs/svelte-grid";

    export let airshowRoute;

    import LoadingAnim from "./loadingAnim.svelte"
    import SlideshowModal from './slideshowModal.svelte';
    let showSlideshow = false;
    let slideshowImages = [];
    let currentSlideshowImage = {};
    let currentSlideshowImageID = null;

    import { operationStore, query } from '@urql/svelte';
    const getArishow = operationStore(`
        query ($airshowRoute: [String]) {
        airshow: entry(section: "airshows", slug: $airshowRoute) {
            title
            airshowDate: postDate @formatDateTime (format: "d.m.Y", timezone: "Europe/Zurich")
            airshowDateMR: postDate @formatDateTime (format: "Y-m-d", timezone: "Europe/Zurich")
        ... on airshows_default_Entry {
                airshowText
                images {
                    id
                    gridViewUrl: url @transform(handle: "grid", immediately: true)
                    detailViewUrl: url @transform(handle: "detail", immediately: true)
                ... on airplanes_Asset {
                        airplaneCategories: airplaneCategory {
                            id
                            title
                            category: parent {
                                id
                                title
                            }
                        }
                        countries: country {
                            id
                            title
                        }
                        registrations: registration {
                            id
                            title
                        }
                        capturePlace {
                            id
                            title
                        }
                        airlineOperators: airlineOperator {
                            id
                            title
                        }
                        captureDate @formatDateTime (format: "Y-m-d", timezone: "Europe/Zurich")
                        specialPaint
                        doubleSeater
                        flares
                        afterburner
                        landingGear
                        breakParachute
                        waterPlane
                        static
                        military
                        museum
                        closeup
                    }
                }
            }
        }

    }`, {airshowRoute});
    query(getArishow);
    getArishow.subscribe(query => {
        if(!query.fetching && query.error === undefined) {
            slideshowImages = query.data.airshow.images;
        }
        console.log(query)
    });

    function onImageClick() {
        currentSlideshowImageID = this.dataset.id;
        currentSlideshowImage = slideshowImages.find( ({ id }) => id === currentSlideshowImageID );
        showSlideshow = true;
    }
</script>
<main class="content airshow">
    {#if $getArishow.fetching}
        <LoadingAnim/>
    {:else if $getArishow.error}
        <p>Oh no... {$getArishow.error.message}</p>
    {:else}
        <div class="title-area">
            <h1>{$getArishow.data.airshow.title}</h1>
        </div>
        <MasonryGrid class="masonry-grid" gap={35}>
            <div class="item airshow-text" data-grid-maintained-target="true">
                {@html $getArishow.data.airshow.airshowText}
                <div class="date">
                    <!--<span>Airshow vom</span> --><time datetime="{$getArishow.data.airshow.airshowDateMR}">{$getArishow.data.airshow.airshowDate}</time>
                </div>
            </div>
            {#each $getArishow.data.airshow.images as image}
                <div class="item">
                    <img src="{image.gridViewUrl}" data-grid-maintained-target="true" data-id="{image.id}" on:click={onImageClick}>
                </div>
            {/each}
        </MasonryGrid>
    {/if}
    <SlideshowModal bind:open={showSlideshow} bind:currentSlideshowImageID={currentSlideshowImageID} bind:currentSlideshowImage={currentSlideshowImage} bind:slideshowImages={slideshowImages} />
</main>
<style lang="scss">
    .date {
      text-align: right;
      margin-top: calc(var(--default-margin) / 2);
    }

    .airshow-text {
        background-color: white;
      padding: var(--default-padding);
    }
</style>